module.exports = __webpack_public_path__ + "static/img/30012 (5).871b149.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (5).webp
// module id = oU3l
// module chunks = 14